const initialState = {
  showStripeModal: false,
  total: "",
  interval: "",
  productIdentifier: "",
  showUpdateSubscriptionModal: false,
  showUpdateCardModal: false,
  showCancelReactivateSubscriptionModal: false,
  showCancelSurveyModal: false,
  reactivating: false,
  seats: 1,
  isFetchingInvoices: false,
  isFetchingPlans: false,
  canLoadMore: true
}

function subs(state = initialState, action) {
  switch (action.type) {
    case "GET_INVOICES_REQUEST":
    case "GET_MORE_INVOICES_REQUEST":
      return { ...state, isFetchingInvoices: true }

    case "GET_INVOICES_FAIL":
    case "GET_INVOICES_SUCCESS":
    case "GET_MORE_INVOICES_FAIL":
    case "GET_MORE_INVOICES_SUCCESS":
      return {
        ...state,
        isFetchingInvoices: false,
        canLoadMore: action.data.length > 0
      }

    case "GET_PLANS_REQUEST":
      return { ...state, isFetchingPlans: true }

    case "GET_PLANS_SUCCESS":
      return { ...state, isFetchingPlans: false }

    case "CLOSE_SUB_MODAL":
      return {
        ...state,
        showUpdateSubscriptionModal: false,
        showUpdateCardModal: false,
        showCancelReactivateSubscriptionModal: false,
        showStripeModal: false
      }
    case "SELECT_PLAN":
      return {
        ...state,
        ...action.plan
      }
    case "RESET_SUBS":
      return initialState

    case "OPEN_SURVEY_MODAL":
      return {
        ...state,
        showCancelSurveyModal: true
      }

    case "CLOSE_SURVEY_MODAL":
      return {
        ...state,
        showCancelSurveyModal: false
      }
    case "CANCEL_REACTIVATE":
      return {
        ...state,
        showCancelReactivateSubscriptionModal: true,
        reactivating: action.reactivating
      }
    case "UPDATE_CARD_SELECT":
      return {
        ...state,
        showUpdateCardModal: true
      }

    default:
      return state
  }
}

export default subs



// WEBPACK FOOTER //
// ./src/subscriptions/reducer.js